// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 374) return "static/chunks/374-25f1b46fe73a6d02.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"140":"3bbb0ef20887de38","239":"be668ce18e2e79c3","553":"dea20a29ca447610","863":"9ba25a5d203a4ccb","905":"11ae935e9e54c281"}[chunkId] + ".js";
};